import './add-bank-account.modal.scss';

export default function AddBankAccountModal($scope, close, country, $alert, $t) {
  'ngInject';

  $scope.bank = {};
  $scope.country = country;

  const getRoutingNumber = (part1, part2) => {
    if (!part1) {
      return null;
    }

    if (!part2) {
      return part1;
    }

    const separator = country.routingNumber.separator;

    if (separator) {
      return part1 + separator + part2;
    }

    return part1 + part2;
  };

  $scope.ok = (form) => {
    if (form.$valid) {
      if ($scope.bank.accountNumber !== $scope.bank.confirmAccountNumber) {
        $alert.error($t('shared.modals.add_bank_account.account_numbers_equal_error'))
        return;
      }

      const data = {
        accountNumber: $scope.bank.accountNumber,
        routingNumber: getRoutingNumber($scope.bank.routingPart1, $scope.bank.routingPart2),
        currency: 'USD'
      };

      close(data);
    }
  };

  $scope.close = () => {
    close();
  };

}